package com.anjuros.website.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.ResKey
import com.anjuros.website.templates.selection.components.RichText
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.styles.Header1CenterStyle
import com.anjuros.website.templates.selection.styles.Header2Style
import com.anjuros.website.templates.selection.styles.SeeAllButtonStyle
import com.anjuros.website.templates.selection.util.Constants
import com.anjuros.website.templates.selection.util.Constants.DEV_WEB
import com.anjuros.website.templates.template4.styles.Template4ProjectButtonStyle
import com.anjuros.website.templates.template4.util.Template4Constants
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.CSSPercentageValue
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLLinkElement
import org.w3c.dom.HTMLMetaElement

@Composable
fun Header1(
    modifier: Modifier = Header1CenterStyle.toModifier(),
    resKey: ResKey,
    color: CSSColorValue = Theme.ShowcaseButton.rgb){
    H1(
        attrs = modifier

            .color(color)
            .fontFamily(Constants.FONT_FAMILY)
            .textDecorationLine(TextDecorationLine.None)

            .fontStyle(FontStyle.Normal)
            .fontWeight(FontWeight.Bold)
            .styleModifier {
                property(
                    "text-shadow",
                    "0 2px 4px rgba(0,0,0,0.25)"
                )
            }
            .toAttrs()
    ) {
        Text(LocalText(resKey))

    }
}

@Composable
fun Header2(
    modifier: Modifier = Header2Style.toModifier(),
    resKey: ResKey,
    topBottomMargin:CSSLengthOrPercentageNumericValue = 20.px,
    textAlign: TextAlign = TextAlign.Left,
    fontWeight: FontWeight = FontWeight.Bold,
    color :CSSColorValue = Theme.ShowcaseButton.rgb,
    fillMaxWidth:CSSPercentageValue = 90.percent
){
    H2(
        attrs = modifier
            .fillMaxWidth(fillMaxWidth)
            .margin(topBottom = topBottomMargin)
            .fontFamily(Constants.FONT_FAMILY)
            .textAlign(textAlign)
            .color(color)

            .fontWeight(fontWeight)
            .toAttrs()
    ) {
        RichText(LocalText(resKey))
    }
}

@Composable
fun Paragraph1(
    modifier: Modifier = Modifier,
    resKey: ResKey,
    topBottom: CSSLengthOrPercentageNumericValue = 20.px,
    maxWidth : CSSLengthOrPercentageNumericValue = 80.percent,
    color: CSSColorValue = Theme.ShowcaseButton.rgb,

) {
    P(
        attrs = modifier
                .margin(topBottom = topBottom)
                .fillMaxWidth(maxWidth)
                .fontFamily(Constants.FONT_FAMILY)
                .color(color)
                .fontSize(22.px)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
    ) {
        Text(LocalText(resKey))
    }
}

@Composable
fun Paragraph2(
    resKey: ResKey,
    topBottomMargin: CSSLengthOrPercentageNumericValue = 10.px
) {
    P(
        attrs = Modifier
            .margin(topBottom =topBottomMargin)
            .fontFamily(Constants.FONT_FAMILY)
            .color(Theme.ShowcaseButton.rgb)
            .fontSize(20.px)
            .fontWeight(FontWeight.Normal)
            .toAttrs()
    ) {
        Text(LocalText(resKey))
    }
}

@Composable
fun BulletPoint1(
    resKey: ResKey,
    fontWeight: FontWeight=FontWeight.Normal,
    color: CSSColorValue = Theme.ShowcaseButton.rgb
){
    P(
        attrs = Modifier
            .fillMaxWidth()
            .margin(topBottom = 2.px, leftRight = 4.px)
            .fontFamily(Constants.FONT_FAMILY)
            .color(color)
            .textAlign(TextAlign.Start)
            .fontSize(18.px)
            .fontWeight(fontWeight)
            .toAttrs()
    ) {
        Row(
            modifier = Modifier.margin(left = 8.px,bottom = 4.px),
            horizontalArrangement = Arrangement.spacedBy(4.px), // Creates space between bullet and text
            verticalAlignment = Alignment.Top // Aligns bullet with the top line of text
        ) {
            SpanText(
                "•",
                modifier = Modifier
                    .color(color)
            )
            RichText(LocalText(resKey))
        }
    }
}
@Composable
fun CTAButton1(
    modifier: Modifier = Modifier,
    text:ResKey,
    top: CSSLengthOrPercentageNumericValue = 40.px,
    path:String,
    style: Modifier = SeeAllButtonStyle.toModifier()
) {
    Link(
        modifier = modifier
            .textDecorationLine(TextDecorationLine.None)
        ,
        path = path
    ) {
        Box(
            modifier = style

                .margin(top = top)
        ) {

            Row(
                modifier = Modifier.align(Alignment.Center),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(LocalText(text))
                Span(
                    Modifier
                        .margin(left = 4.px)
                        .toAttrs()

                ) {
                    Text("→")
                }
            }
        }
    }
}

fun setMeta(title: String,
            description: String,
            image: String = "https://www.soletraderwebsite.co.uk/blog1_img1.jpg",
            url:String ="https://www.soletraderwebsite.co.uk" ) {
    document.title = title

    document.title = title

    // Description
    setMetaTag(
        "meta[name='description']",
        "name",
        "description",
        description
    )

    //fb
    setMetaTag(
        "meta[property='og:title']",
        "property",
        "og:title",
        title
    )

    setMetaTag(
        "meta[property='og:description']",
        "property",
        "og:description",
        description
    )

    setMetaTag(
        "meta[property='og:type']",
        "property",
        "og:type",
        "website"
    )

    setMetaTag(
        "meta[property='og:url']",
        "property",
        "og:url",
        url
    )

    setMetaTag(
        "meta[property='og:image']",
        "property",
        "og:image",
        image
    )

}

private fun setMetaTag(
    selector: String,
    attrName: String,
    attrValue: String,
    content: String
) {
    val existing = document.querySelector(selector)
    val meta = (existing ?: document.createElement("meta")) as HTMLMetaElement

    meta.setAttribute(attrName, attrValue)
    meta.content = content

    if (existing == null) {
        document.head?.appendChild(meta)
    }
}

fun setSpamJs(){
    if (document.getElementById("cf-turnstile-script") == null) {
        val script = document.createElement("script")
        script.id = "cf-turnstile-script"
        script.setAttribute(
            "src",
            "https://challenges.cloudflare.com/turnstile/v0/api.js"
        )
        script.setAttribute("async", "")
        script.setAttribute("defer", "")

        document.head?.appendChild(script)
    }
}

fun addStylesheet(href: String) {
    val selector = "link[rel='stylesheet'][href='$href']"

    if (document.querySelector(selector) == null) {
        val link = document.createElement("link") as HTMLLinkElement
        link.rel = "stylesheet"
        link.href = href

        document.head?.appendChild(link)
    }
}
